import React, { useState, useRef, useEffect, useContext } from 'react';
import { FaFire } from 'react-icons/fa';
import CategoryModal from '../elements/CategoryModal';
import { BsArrowUpCircle, BsInfoCircle } from 'react-icons/bs';
import { MdOutlineRemoveShoppingCart } from 'react-icons/md';
import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Context from '../Context';
import "./menu.css"

export default function Menu({ restaurant,  }) {
  const [categoryModalVisible, setCategoryModalVisible] = useState(false);
  const [activeCategory, setActiveCategory] = useState(0);
  const [modal, setModal] = useState(false);
  const [item, setItem] = useState(null);
  const { language } = useContext(Context);
  const availableFlags = [
    { id: 'mild', name: 'Mild (Spicy)', icon: '🌶️' },
    { id: 'hot', name: 'Medium (Spicy)', icon: '🌶️🌶️' },
    { id: 'extrahot', name: 'Hot (Spicy)', icon: '🌶️🌶️🌶️' },
    { id: 'raw', name: 'Raw', icon: '🐟' },
    { id: 'nut_free', name: 'Nut Free', icon: '🥜' },
    { id: 'gluten_free', name: 'Gluten Free', icon: '🫓' },
    { id: 'dairy_free', name: 'Dairy Free', icon: '🥛' },
    { id: 'vegan', name: 'Vegan', icon: '🌿' },
    { id: 'vegetarian', name: 'Vegetarian', icon: '🥦' },
    { id: 'halal', name: 'Halal', icon: '🕌' },
  ];

  const handleCategoryClick = (categoryId) => {
    setActiveCategory(categoryId);
    setCategoryModalVisible(false);
    const categoryOffset = getCategoryOffset(categoryId);
    if (categoryOffset) {
      window.scrollTo({ top: categoryOffset, behavior: 'smooth' });
    }
  };

  const getCategoryOffset = (categoryId) => {
    const categoryElement = document.getElementById(`category-${categoryId}`);
    if (categoryElement) {
      const rect = categoryElement.getBoundingClientRect();
      return rect.top + window.scrollY - 200;
    }
    return 0;
  };

  useEffect(() => {
    // Handle hash navigation
    const handleHashChange = () => {
      const hash = window.location.hash;
      if (hash) {
        // Remove the '#' and find the category
        const categoryName = hash.substring(1);
        const categoryIndex = restaurant?.Categories.findIndex(category =>
          category.name.toLowerCase() === categoryName.toLowerCase()
        );

        if (categoryIndex !== undefined && categoryIndex >= 0) {
          // Set active category
          setActiveCategory(categoryIndex);

          // Scroll to category after a short delay to ensure DOM is ready
          setTimeout(() => {
            const categoryOffset = getCategoryOffset(categoryIndex);
            if (categoryOffset) {
              window.scrollTo({ top: categoryOffset, behavior: 'smooth' });
            }
          }, 100);
        }
      }
    };

    // Check hash on initial load
    handleHashChange();

    // Listen for hash changes
    window.addEventListener('hashchange', handleHashChange);

    // Cleanup listener
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, [restaurant]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + 250;
      restaurant?.Categories.forEach((category, index) => {
        const categoryElement = document.getElementById(`category-${index}`);
        if (categoryElement) {
          const offsetTop = categoryElement.offsetTop;
          const offsetHeight = categoryElement.offsetHeight;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveCategory(index);
          }
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [restaurant]);

  return (
    <div className="menu-container">
        <div className="container">
            <div className="menu-card-main">
                {/* menu card corner images */}
                <img className="menu-card-corner top-left" src="/images/resource/menucard-corner-left-top.png"
                     alt="image"/>
                <img className="menu-card-corner top-right" src="/images/resource/menucard-corner-right-top.png"
                     alt="image"/>
                <img className="menu-card-corner bottom-left" src="/images/resource/menucard-corner-left-bottom.png"
                     alt="image"/>
                <img className="menu-card-corner bottom-right" src="/images/resource/menucard-corner-right-bottom.png"
                     alt="image"/>
                {
                    restaurant?.Categories.map((category, index) => (
                        <>
                            {/* menu box */}
                            <div className={`menu-card-style ${index % 2 === 0 ? 'alternate' : ''}`}>
                                <div className="row clearfix">
                                    <div className="image-col col-lg-6 col-md-12 col-sm-12">
                                        <div className="inner">
                                            <div className="image"><img src={`/images/resource/${category.name.toLowerCase().replace(/[^a-zA-Z0-9]/g, '')}.jpg`} alt={category.name}/></div>
                                        </div>
                                    </div>

                                    <div className="menu-col col-lg-6 col-md-12 col-sm-12">
                                        <div className="inner">
                                            <div className="title-box" id={`category-${index}`} key={category.id}>
                                                <h3>{category.name}</h3>
                                            </div>
                                            {category.Items.map((itm) => (
                                                <>
                                                    <div className="dish-block" onClick={() => { setItem(itm); setModal(true); }}>
                                                        <div className="inner-box">
                                                            <div className="title clearfix">
                                                                <div className="ttl clearfix"><h6><a href="javascript:void(0)" title="{language == 'en' ? itm?.name : itm?.chinese_name}">
                                                                    {language == 'en' ? (itm?.name.length > 20 ? itm.name.substring(0, 20) + '...' : itm.name) : (itm?.chinese_name.length > 10 ? itm.chinese_name.substring(0, 10) + '...' : itm.chinese_name)}
                                                                </a></h6>
                                                                </div>
                                                                <span className="menu-list-line"> </span>
                                                                <div className="price"><span>
                                                                    {itm?.market_price ? 'Market Price' : <>${itm.price}</>}
                                                                </span></div>
                                                            </div>
                                                            <div className="text desc">
                                                                {itm?.description && itm.description !== 'null' && (
                                                                    <a href="javascript:void(0)" title="{itm.description}">
                                                                        {language === 'en' ? (itm.description.length > 100 ? itm.description.substring(0, 100) + '...' : itm.description) : (itm.description.length > 50 ? itm.description.substring(0, 50) + '...' : itm.description)}
                                                                    </a>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    ))
                }

                <CategoryModal show={categoryModalVisible} onClose={() => setCategoryModalVisible(false)}>
                    <div className="p-3">
                        {restaurant?.Categories.map((category, index) => (
                            <div
                                key={category.id}
                                className={`category-list2 p-2 rounded text-center fw-medium mb-2 ${activeCategory === index ? 'active' : 'bg-light text-dark'}`}
                                onClick={() => handleCategoryClick(index)}
                            >
                                {category.name}
                            </div>
                        ))}
                    </div>
                </CategoryModal>

            </div>
        </div>
        <button
            onClick={() => setCategoryModalVisible(true)}
            className="btn w-100 position-fixed bottom-0 start-0 rounded-top fw-semibold d-flex justify-content-center align-items-center gap-2 py-3 shadow"
            style={{ backgroundColor: '#f7efd7', color: '#1a1815', zIndex: 1000 }}
        >
            {restaurant?.Categories[activeCategory]?.name || 'Categories'}
            <BsArrowUpCircle className="ms-2" />
        </button>

        <Modal show={modal} onHide={() => setModal(false)} centered scrollable size="lg">
            <Modal.Header closeButton className="border-0 pb-0">
                <Modal.Title className="w-100 text-center text-dark fw-bold">
                    {language === 'en' ? item?.name : item?.chinese_name}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="px-4 py-2">
                {item?.image_url && (
                    <div className="mb-3 position-relative rounded overflow-hidden">
                        <img src={item.image_url} alt={item?.name} className="w-100 rounded"  style={{height:'250px'}}/>
                        {item.hot_item && (
                            <div className="position-absolute top-0 end-0 bg-danger text-white small px-2 py-1 rounded m-2 d-flex align-items-center">
                                <FaFire className="text-warning me-1" /> Popular
                            </div>
                        )}
                        {item?.price && (
                            <div className="position-absolute bottom-0 end-0 bg-white bg-opacity-75 text-dark small fw-semibold px-3 py-1 rounded m-2 d-flex align-items-center">
                                {item.market_price ? (
                                    <>
                                        <span className="me-2">Market Price</span>
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={<Tooltip id="tooltip-marketprice">Market Price means the price varies daily based on current seafood or ingredient costs.</Tooltip>}
                                        >
                                            <BsInfoCircle className="text-info" style={{ cursor: 'pointer' }} />
                                        </OverlayTrigger>
                                    </>
                                ) : (
                                    <span>${item.price}</span>
                                )}
                            </div>
                        )}
                    </div>
                )}

                {Array.isArray(item?.flags) && item?.flags.length > 0 && (
                    <div className="mb-3 d-flex flex-wrap gap-2">
                        {availableFlags.filter(flag => item.flags.includes(flag.id)).map(flag => (
                            <span key={flag.id} className="badge bg-light border text-dark d-flex align-items-center gap-1">
                  <span>{flag.icon}</span>
                  <span>{flag.name}</span>
                </span>
                        ))}
                    </div>
                )}

                {item?.description && item.description !== 'null' && (
                    <p className="text-muted border-bottom pb-2">{item.description}</p>
                )}

                {item?.Restaurant_Item_Attributes?.length > 0 && (
                    <div className="mt-3">
                        <h6 className="fw-semibold text-dark mb-2">Options Available</h6>
                        {item.Restaurant_Item_Attributes.map(attr => (
                            <div key={attr.id} className="mb-3">
                                <div className="fw-medium small mb-1">-{attr?.Item_Attribute?.name}</div>
                                <div className="d-flex flex-wrap gap-2">
                                    {attr.Item_Attribute.Item_Attribute_Options?.map(option => (
                                        <span
                                            key={option.id}
                                            className="badge bg-light border text-dark d-flex align-items-center gap-1"
                                        >
                        {option.name}
                                            {option.price_modifier > 0 && (
                                                <span className="text-secondary small">+${option.price_modifier}</span>
                                            )}
                      </span>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </Modal.Body>
        </Modal>
    </div>
  );
}
